<template>
  <div>

    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <div class="item">
          <el-select v-model="datas.type" placeholder="请选择" clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 开始时间 -->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="00:00:00" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 搜索 -->
        <div class="item">
          <el-button type="primary" @click="pushList">{{ $t("message.search") }}</el-button>
        </div>
        <div class="add">
          <!-- 群发信息 -->
          <router-link to="/rakuMessaging" target="_blank" v-if="isAuth(402)">
            <el-button type="success">
              {{ $t("message.massMessaging") }}
            </el-button>
          </router-link>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 收件人 -->
          <el-table-column align="center" :label="$t('message.recipients')" width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.type == '全部客户'">
                {{ scope.row.type }}</span>
              <el-button type="text" v-else @click="pushUserList(scope.row)">
                {{ scope.row.type }}
              </el-button>
            </template>
          </el-table-column>
          <!-- 内容 -->
          <el-table-column align="center" :label="$t('message.content')" prop="content">
            <template slot-scope="scope">
              <div v-html="scope.row.content" class="content"></div>
            </template>
          </el-table-column>
          <!-- 添加日期 -->
          <el-table-column align="center" :label="$t('message.addDate')" width="200" prop="created_at">
          </el-table-column>
          <!-- 定时发送时间 -->
          <el-table-column align="center" :label="$t('message.timedTransmissionTime')" width="200" prop="send_at">
          </el-table-column>
          <!-- 发送状态 -->
          <el-table-column align="center" :label="$t('message.sendingStatus')" width="200" prop="status">
            <template slot-scope="scope">
              {{ scope.row.status_name }}
              <div class="num">
                <div class="item" @click="pushLogList(scope.row.id, 1)">
                  成功:{{ scope.row.success_count }}
                </div>
                <div class="item" @click="pushLogList(scope.row.id, 2)">
                  失败：{{ scope.row.fail_count }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 人员列表 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="600px" center>
      <el-table :data="userData" border :header-cell-style="{ background: '#EDEFF4' }" max-height="500px">
        <!-- 客户ID -->
        <el-table-column prop="id" label="ID" align="center" width="100">
        </el-table-column>
        <!--客户名称-->
        <el-table-column prop="realname" label="客户名称" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 发送列表 -->
    <el-dialog :close-on-click-modal="false" title="发送列表" :visible.sync="logDialogVisible" width="600px" center>
      <el-table :data="logList" border :header-cell-style="{ background: '#EDEFF4' }" max-height="500px">
        <!-- 客户信息 -->
        <el-table-column label="客户信息" align="center">
          <template slot-scope="scope">
            <p>
              ID:{{ scope.row.user_id }}
            </p>
            <p>
              名称:{{ scope.row.realname }}
            </p>
          </template>
        </el-table-column>
        <!--状态-->
        <el-table-column prop="status_name" label="状态" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import preview from "../announcement/preview";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    preview,
    quillEditor,
  },

  data() {
    return {
      activeName: 1,
      quillOption: quillConfig,
      editDialogVisible: false,
      dialogVisible: false,

      datas: {
        type: "",
        dateStart: "",
        dateEnd: "",
        pageSize: 999
      },

      tableData: [],
      item: {},
      userData: [],
      editData: {},
      rules: {
        title: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],

      },

      yData: {
        id: '',
        realname: '',
      },
      y: [],
      userDialogVisible: false,

      //  单条日志查看
      logList: [],
      logDialogVisible: false,
      options: [
        {
          label: "全部客户",
          value: "全部客户",
        },
        {
          label: "部分客户",
          value: "部分客户",
        },

      ],

    };
  },
  created() {
    // 同组织各工种账号列表
    this.$api.getAuthWorkGroupAdminSameLevel().then(res => {
      this.y = res.data.y
    })
    this.pushList();
  },
  methods: {

    pushList() {
      this.$api.noticeApi.pushList(this.datas).then((res) => {
        this.tableData = res.data.data
      });
    },
    //查看
    look(item) {
      this.item = item;
      this.$refs.preview.dialogVisible = true;
    },
    //部分用户列表
    pushUserList(item) {
      this.$api.noticeApi.pushUserList({ msg_id: item.id }).then((res) => {
        this.userData = res.data
        this.dialogVisible = true
      });

    },
    //批量删除通知
    templateDelete(id) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.noticeApi.templateDelete({ id }).then(res => {
            this.$message.success(res.msg)
            this.pushList()
          })
        })
        .catch(() => { });
    },
    //编辑
    redact(item) {
      this.editData = JSON.parse(JSON.stringify(item))
      this.editDialogVisible = true
    },
    //寻找业务员名称
    setRealname(e) {
      this.yData.realname = this.y.find(item => item.id == e).realname
    },
    // 单条日志查看
    pushLogList(id, status) {
      let datas = {
        msg_id: id,
        status
      }
      this.$api.noticeApi.pushLogList(datas).then(res => {
        this.logList = res.data.data
        this.logDialogVisible = true
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;
  flex-wrap: wrap;

  .item {
    width: 240px;
  }

  .add {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.table {
  margin: 20px 0;
}

.content {
  max-height: 100px;
  overflow-y: auto;
}

/deep/.ql-editor {
  height: 300px !important;
}

.num {
  display: flex;
  width: 100%;

  .item {
    flex: 1;
    justify-content: center;
    align-items: center;
    color: #85ce61;
    cursor: pointer;

    &:nth-last-child(1) {
      color: red;
    }
  }
}
</style>